module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-06.d539d2e5.svg";